import React from "react";

const WaterStorage_Handling = ({ quotationType = null, data }) => {
  let serial = 1;
  return (
    <div>
      <h3 style={{ marginTop: "40px" }}>Water Storage and Handling</h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>

        <tbody>
          {quotationType !== "fanpad" &&
            quotationType !== "nvph" &&
            quotationType !== "nethouse" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" &&
            quotationType !== "soilbasednethouse" && (
              <>
                <tr>
                  <td>{serial++}.</td>
                  <td>Water tank</td>
                  <td>
                    Water tank of Food-grade plastic and installation of water
                    tank will be provided by us.
                  </td>
                </tr>
                {/* <tr>
                  <td>{serial++}.</td>
                  <td>Reservoir tank dig</td>
                  <td>
                    While land levelling with help of JCB reservoir tank spot
                    will be dug. Placement of reservoir tank is purely based of
                    land slope and determined after primary inspection of KBPL
                    team.
                  </td>
                </tr> */}
                <tr>
                  <td>{serial++}.</td>
                  <td>ABC mother tanks</td>
                  <td>
                    ABC nutrient mother tanks with capacity of 75ltr - 100ltr
                    each.
                  </td>
                </tr>
                <tr>
                  <td>{serial++}.</td>
                  <td>Water tank capacity</td>
                  <td>
                    Water tank will have a water capacity based on plantation
                    and system design.
                  </td>
                </tr>
                <tr>
                  <td>{serial++}.</td>
                  <td>Water filter / water treatment</td>
                  <td>
                    In case of high TDS water, Water treatment installation may
                    be required. You are free to obtain rain water harvesting or
                    RO. KBPL will do the job of connecting it to the mainline
                    system. Actual water treatment will be in scope of you and
                    the company you are buying the unit from.
                  </td>
                </tr>
              </>
            )}
          {data?.a_FramePercent > 0 && (
            <tr>
              <td>{serial++}.</td>
              <td>UV light assembly</td>
              <td>
                UV light treatment assembly is used to treat fungal infection,
                algae formation, and bacterial & pathogen growth.
              </td>
            </tr>
          )}
          {data?.asPerIndustry?.includes("iot_automation_screen_display") && (
            <tr>
              <td>{serial++}.</td>
              <td>Automation unit installation channels</td>
              <td>
                At water level the option to add an automation unit will be
                added with help of filters, fittings, piping's, and check
                valves.
              </td>
            </tr>
          )}
          {data?.asPerIndustry?.includes("fogger_system_netafim") && (
            <tr>
              <td>{serial++}.</td>
              <td>4-Way foggers assembly</td>
              <td>
                65 Micron, LPD fitted, High pressure 4-way foggers, lateral
                piping, PVC headers, fittings, fogger motor, etc.
              </td>
            </tr>
          )}
          {data?.asPerIndustry?.includes("fogger_system_netafim") && (
            <tr>
              <td>{serial++}.</td>
              <td>Fogger tank</td>
              <td>
                A fogger tank will be provided separately to facilitate regular
                water top-ups during the summer season.
              </td>
            </tr>
          )}

          {quotationType === "fanpad" &&
            quotationType !== "soilbasedfanpad" && (
              <>
                <tr>
                  <td>{serial++}.</td>
                  <td>Water tank for padding system</td>
                  <td>
                    Water tank for padding system to drain water in multiples of
                    2000ltr as per project size.
                  </td>
                </tr>
                <tr>
                  <td>{serial++}.</td>
                  <td>Fan Pad Water tank recycling and drainage</td>
                  <td>
                    Water tank recycling and drainage system with recollection
                    of dropped water.
                  </td>
                </tr>
                {/* <tr>
                <td>{serial++}.</td>
                <td>4 way fogging system</td>
                <td>4 Way fogging system for humidity with all fittings.</td>
              </tr> */}
              </>
            )}
        </tbody>
      </table>
    </div>
  );
};

export default WaterStorage_Handling;
